import React, { Fragment } from 'react'
import { BulkDeleteButton, Datagrid, DeleteButton, List, TextField, translate } from 'react-admin'
import { AssetTypeListActions } from './AssetTypeListActions'

const PostBulkActionButtons = (props) => (
  <Fragment>
    <BulkDeleteButton disabled={!props.permissions?.includes('delete:assets')} {...props} />
  </Fragment>
)

const AssetTypeList = ({ accessible, dispatch, permissions, ...props }) => {
  return (
    <List
      bulkActionButtons={<PostBulkActionButtons permissions={permissions} />}
      actions={<AssetTypeListActions />}
      {...props}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        {permissions?.includes('delete:assets') && <DeleteButton />}
      </Datagrid>
    </List>
  )
}

export default translate(AssetTypeList)
